import httpClient from 'api/httpClient';
import { Fleet } from 'models/Fleet';
import { PaginatedData, PaginationParams } from 'models/Pagination';

function getFleets(params?: PaginationParams) {
  return httpClient.get<PaginatedData<Fleet>>('fleets', {
    params,
  });
}

export default {
  getFleets,
};
